module.exports = new __parcel__URL__("../images/marker.da1fc66d.svg").toString();